import React, { useState } from 'react';
import CopyRow from '../../CopyRow';
import Alert from '../Alert';
import { formatPrice } from '../../basket/basketUtils';

const OrderInfoBlockMobile = ({
                                doNotCall,
                                paymentType,
                                paymentStatus,
                                discountedPrice,
                                orderId,
                                paymentSettings,
                                items
                              }) => {

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleCopied = (label) => {
    setAlertMessage(`📋 ${label} скопійовано`);
    setShowAlert(true);
  };

  // Перевірка, чи всі товари є передзамовленням
  const isAllPreorder = items && items.length > 0 && items.every(item => 
    item.productOrderType && item.productOrderType.databaseValue === 'PREORDER'
  );

  // Перевірка, чи є хоча б один товар з передзамовленням (але не всі)
  const isPartialPreorder = items && items.length > 0 && 
    items.some(item => item.productOrderType && item.productOrderType.databaseValue === 'PREORDER') && 
    !isAllPreorder;

  // Функція для отримання тексту про відправку
  const getShippingText = () => {
    if (isAllPreorder) {
      return 'Відправка відбудеться після дати релізу.';
    }
    if (isPartialPreorder) {
      return 'Ваше замовлення частково містить товари з передзамовлення, тому відправка відбудеться після дати релізу. Якщо ви бажаєте розділити замовлення - напишіть нам в телеграм';
    }
    return 'Відправка протягом 1–2 робочих днів.';
  };

  return (
    <div>
      <Alert
        show={showAlert}
        setShow={setShowAlert}
        message={alertMessage}
        timeout={1500}
      />

      {doNotCall && paymentType === 'Оплата при отриманні' && (
        <div className='card mb-3'>
          <div className='card-body px-3 py-2'>
            <div className='font-weight-bold mb-1'>
              ✅ {isAllPreorder ? 'Передзамовлення' : 'Замовлення'} {orderId} підтверджено автоматично
            </div>

            <p className='mb-2'>
              Ви обрали <strong>оплату при отриманні</strong> та опцію{' '}
              <strong>«не дзвонити»</strong>, тому ми одразу взяли замовлення в роботу.
            </p>

            <p className='mb-0'>
              📦 <strong>{getShippingText()}</strong>
            </p>
          </div>
        </div>
      )}

      {!doNotCall && paymentType === 'Оплата при отриманні' && (
        <div className='card mb-3'>
          <div className='card-body px-3 py-2'>
            <div className='font-weight-bold mb-1'>
              ✅ Замовлення {orderId} прийнято
            </div>

            <p className='mb-2'>
              Ви обрали <strong>оплату при отриманні</strong>. Очікуйте на дзвінок менеджера для підтвердження
              замовлення
            </p>

            <p className='mb-0'>
              📦 <strong>{getShippingText()}</strong>
            </p>
          </div>
        </div>
      )}

      {paymentType === 'Карткою' && paymentStatus === 'Не оплачений' && (
        <div className='card mb-3'>
          <div className='card-body px-3 py-2'>

            <div className='font-weight-bold mb-1'>
              ✅ {isAllPreorder ? 'Передзамовлення' : 'Замовлення'} {orderId} прийнято
            </div>

            {paymentSettings && paymentSettings.recipient && paymentSettings.iban && paymentSettings.edrpou && (
              <>
                <p className='mb-2'>
                  Ви обрали розрахунок <strong>за IBAN реквізитами</strong>.
                </p>

                <p className='mb-3'>
                  Для пришвидшення відправки ви можете
                  <strong> одразу оплатити замовлення</strong>{' '}
                  за реквізитами нижче.
                </p>
              </>
            )}
          </div>


          {paymentSettings && paymentSettings.recipient && paymentSettings.iban && paymentSettings.edrpou && (
            <>
              <div className='border rounded p-3 mt-2 bg-light'>
                <CopyRow
                  label='Одержувач'
                  value={paymentSettings.recipient}
                  onCopied={handleCopied}
                />

                <CopyRow
                  label='IBAN'
                  value={paymentSettings.iban}
                  monospace
                  onCopied={handleCopied}
                />

                <CopyRow
                  label='ЄДРПОУ'
                  value={paymentSettings.edrpou}
                  onCopied={handleCopied}
                />

                <CopyRow
                  label='Призначення'
                  value={`оплата за замовлення №${orderId}`}
                  onCopied={handleCopied}
                />

                <CopyRow
                  label='Сума'
                  value={`${formatPrice(discountedPrice)} грн`}
                  copyValue={discountedPrice}
                  onCopied={handleCopied}
                />
              </div>

              <div className='card-body px-3 py-2'>
                <p className='mb-0'>
                  Після здійснення платежу, будь ласка,{' '}
                  <a
                    href='https://t.me/waaaghShopAdmin'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='font-weight-bold'
                  >
                    повідомте нас у Telegram
                  </a>
                  {' '}
                  {isAllPreorder && (
                    <p>
                      <strong>Оплату можна здійснити і після надходження товару</strong>
                    </p>
                  )}
                </p>
                <p className='mt-2'>
                  📦 <strong>{getShippingText()}</strong>
                </p>
              </div>
            </>
          )}

        </div>
      )}

      {paymentType === 'Карткою' && paymentStatus === 'Оплачений' && (
        <div className='card mb-3'>
          <div className='card-body px-3 py-2'>
            <div className='font-weight-bold mb-1'>
              ✅ {isAllPreorder ? 'Передзамовлення' : 'Замовлення'} {orderId} прийнято{discountedPrice === 0 ? '. Оплата товарів не потрібна.' : ', оплата отримана'}
            </div>

            <p className='mb-0'>
              📦 <strong>{getShippingText()}</strong>
            </p>
          </div>
        </div>
      )}

    </div>
  );
};

export default OrderInfoBlockMobile;
